import { LatLngTuple } from "leaflet"

export type HereLocation = {
  id: string
  title: string
  address: {
    label: string
    city: string
    county: string
    district: string
    postalCode: string
    street: string
    subdistrict: string
  }
  position: {
    lat: number
    lng: number
  }
}

const HERE_API_KEY = process.env.REACT_APP_HERE_API_KEY

export async function fetchLocationsFromHere(searchValue: string, mapCenter: LatLngTuple) {
  try {
    const response = await fetch(
      `https://discover.search.hereapi.com/v1/discover` +
        `?at=${mapCenter}` +
        `&q=${searchValue}&in=countryCode:POL` +
        `&apiKey=${HERE_API_KEY}`
    )

    const json = await response.json()
    return json.items as HereLocation[]
  } catch (error) {
    return null
  }
}

export function getLocationLabels(location: HereLocation) {
  let { label } = location.address
  label = label.replace("ulica", "")
  const splitAt = label.search(/\d\d-\d\d\d/)
  const labels = [label.substring(0, splitAt - 2), label.substring(splitAt)]

  return labels
}
